import { __decorate } from "tslib";
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import InstructorsTableBase from '@/classes/InstructorsTableBase';
import { InstructorTableRowType } from '@/enums/InstructorTableRowType';
import InstructorTableAvailableCell from '@/classes/InstructorTableAvailableCell';
import store from "@/store";
import { NotificationTypes } from "@/enums/NotificationTypes";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
let InstructorsTableEmptyCell = class InstructorsTableEmptyCell extends InstructorsTableBase {
    dataSource;
    rowData;
    hour;
    async addAvailableCellToCurrentUser() {
        if (this.rowData.rowType === InstructorTableRowType.INSTRUCTOR && (this.rowData.isCurrentUserRow() || this.isAdmin())) {
            const availableCell = new InstructorTableAvailableCell(this.rowData);
            if (!this.rowData.isCurrentUserRow()
                && !await ConfirmDialog.open('Upozornění', 'Opravdu chcete ovlivnit dostupnost instruktora? O této změně bude informován.')) {
                return;
            }
            if (!this.rowData.isCurrentUserRow()) {
                await store.dispatch('notification/send', {
                    instructor: this.rowData.instructorId,
                    message: `Admin upravil tvou dostupnost dne ${this.dataSource.date.format('D. M. YYYY')} od ${this.hour}:00`,
                    type: NotificationTypes.ERROR,
                    urgency: this.notificationUrgency,
                    link: { name: 'InstructorsTimeScheduleWithDate', params: { date: this.dataSource.date.format('YYYY-MM-DD') } },
                });
            }
            availableCell.hour = this.hour;
            this.rowData.cells.push(availableCell);
        }
        await this.updateDataSource();
    }
};
__decorate([
    Prop({ required: true })
], InstructorsTableEmptyCell.prototype, "dataSource", void 0);
__decorate([
    Prop({ required: true })
], InstructorsTableEmptyCell.prototype, "rowData", void 0);
__decorate([
    Prop({ required: true })
], InstructorsTableEmptyCell.prototype, "hour", void 0);
InstructorsTableEmptyCell = __decorate([
    Component
], InstructorsTableEmptyCell);
export default InstructorsTableEmptyCell;
